<template>
  <div>
    <router-link class="come-back" to="/admin/convocation_list">
      <div></div>
      Вернуться назад
    </router-link>
    <h2 class="title_categories">{{ $route.query.type === 'edit' ? 'Редактирование состава' : 'Создание состава' }}</h2>
    <tricolor-line class="card_containet__tricolor"/>
    <form @submit.prevent="createConvocation" ref="createConvocation">
      <div>
        <div class="content-sb">
          <p>Название<span>*</span></p>
          <input required placeholder="Введите название" type="text" name="name" v-model="form.name" class="input blue">
        </div>

        <div class="content-sb">
          <p>Название (Англ)<span>*</span></p>
          <input required placeholder="Введите название (Англ)" type="text" name="nameEng" v-model="form.nameEng" class="input blue">
        </div>
      </div>

      <div>
        <div class="content-sb">
          <p>Год начала<span>*</span></p>
          <input required placeholder="Введите название" type="number" name="startPeriod" v-model="form.startPeriod" class="input blue">
        </div>
      </div>

      <div>
        <div class="content-sb">
          <p>Год окончания<span>*</span></p>
          <input required placeholder="Введите название" type="number" name="endPeriod" v-model="form.endPeriod" class="input blue">
        </div>
      </div>

      <footer class="content-sb btns-create-form">
        <router-link to="/admin/convocation_list" class="btn-white">Отмена</router-link>
        <input type="submit" class="btn-blue" :value="$route.query.type === 'edit' ? 'Изменить' : 'Сохранить'"/>
      </footer>
    </form>
  </div>
</template>

<script>
import TricolorLine from '@/components/TricolorLine'

export default {
  name: 'createUser',
  data () {
    return {
      form: this.$route.query.type === 'edit' ? this.$store.getters.getDetailConvocation : {
        name: '',
        nameEng: '',
        endPeriod: null,
        startPeriod: ''
      }
    }
  },
  methods: {
    createConvocation () {
      const formData = new FormData(this.$refs.createConvocation)
      if (this.$route.query.type === 'edit') {
        this.$store.dispatch('editConvocation', this.form)
      } else {
        this.$store.dispatch('createConvocation', formData)
      }
    }
  },
  mounted () {
    if (this.$route.query.type === 'edit' && this.$store.getters.getDetailConvocation === null) {
      this.$router.push('/admin/convocation_list')
    }
  },
  components: {
    TricolorLine
  }
}
</script>

<style lang="scss">
.btns-create-form {
  border-top: 1px solid #D5D6D9;
  padding-top: 2.5rem;
  margin-top: 2.5rem;
}

.content-sb {
  margin-bottom: 1.25rem;

  span {
    color: red;
  }
}

.select, .input {
  width: 33.75rem;
}
</style>
